var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-basic-tab", staticStyle: { "margin-top": "5px" } },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "750px" },
          attrs: {
            inline: true,
            "label-width": "100px",
            "label-position": "right"
          }
        },
        [
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project.ProjectNo"),
                    required: "required"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: true, no: "1" },
                    model: {
                      value: _vm.form.projectNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectNo", $$v)
                      },
                      expression: "form.projectNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("Project.ProjectName"),
                    required: "required"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { disabled: _vm.isEdit, no: "2" },
                    model: {
                      value: _vm.form.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectName", $$v)
                      },
                      expression: "form.projectName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.ProjectStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: "disabled", no: "3" },
                      model: {
                        value: _vm.form.projectStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "projectStatus", $$v)
                        },
                        expression: "form.projectStatus"
                      }
                    },
                    _vm._l(_vm.statusList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: Number(item.code)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Project.CustomerName"),
                    required: "required"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      filterable: "",
                      "actionable-option": function(item) {
                        return item.active
                      },
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "default-value": Number(_vm.form.partener) || "",
                      "method-params": { customer: true, active: true },
                      cache: true,
                      disabled: _vm.isEdit,
                      "tag-name": "chineseName",
                      no: "4"
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.partener = item.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  staticStyle: { "margin-right": "30px" },
                  attrs: {
                    label: _vm.$t("Project.ProjectCycle"),
                    required: "required"
                  }
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "130px" },
                    attrs: { type: "date", disabled: _vm.isEdit, no: "5" },
                    model: {
                      value: _vm.form.dateStart,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dateStart", $$v)
                      },
                      expression: "form.dateStart"
                    }
                  }),
                  _c("span", { staticStyle: { color: "#404144" } }, [
                    _vm._v("- ")
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "130px" },
                    attrs: { type: "date", disabled: _vm.isEdit, no: "6" },
                    model: {
                      value: _vm.form.dateEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dateEnd", $$v)
                      },
                      expression: "form.dateEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("Project.SettleCurrency"),
                    required: "required"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.form.settleCurrency || "",
                      disabled: _vm.isEdit,
                      no: "7"
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.settleCurrency = item.value)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.ExpectIncome") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "8"
                    },
                    on: { change: _vm.checkExpectProfitTate },
                    model: {
                      value: _vm.form.expectIncome,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "expectIncome", $$v)
                      },
                      expression: "form.expectIncome"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.RealIncome") }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "9"
                    },
                    on: { change: _vm.checkRealProfitTate },
                    model: {
                      value: _vm.form.realIncome,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realIncome", $$v)
                      },
                      expression: "form.realIncome"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("Project.ProjectManager"),
                    required: "required"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      "actionable-option": function(item) {
                        return item.active
                      },
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      url: _vm.URL.sys.getUsersByPrivilegeDetail,
                      cache: false,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      filterable: "",
                      "default-value": Number(_vm.form.projectManager) || "",
                      disabled: _vm.isEdit,
                      no: "10"
                    },
                    on: { parentCallBack: _vm.manageCallback }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.ExpectCost") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "11"
                    },
                    on: { change: _vm.checkExpectCostToTal },
                    model: {
                      value: _vm.form.expectCost,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "expectCost", $$v)
                      },
                      expression: "form.expectCost"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.RealCost") }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "12"
                    },
                    on: { change: _vm.checkRealCostToTal },
                    model: {
                      value: _vm.form.realCost,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realCost", $$v)
                      },
                      expression: "form.realCost"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("Project.ProjectDepartment"),
                    required: "required"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      filterable: "",
                      disabled: true,
                      "select-type": _vm.selectTypeNames.basic_data_Department,
                      "default-value": Number(_vm.form.projectDepartment) || "",
                      no: "13"
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.projectDepartment = item.value)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.ExpectExpense") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: _vm.isEdit,
                      no: "14"
                    },
                    on: { change: _vm.checkExpectCostToTal },
                    model: {
                      value: _vm.form.expectExpense,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "expectExpense", $$v)
                      },
                      expression: "form.expectExpense"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.RealExpense") }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: _vm.isEdit,
                      no: "15"
                    },
                    on: { change: _vm.checkRealCostToTal },
                    model: {
                      value: _vm.form.realExpense,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realExpense", $$v)
                      },
                      expression: "form.realExpense"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: {
                    label: _vm.$t("Project.ProjectOffice"),
                    required: "required"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_Office,
                      "default-value": Number(_vm.form.projectOffice) || "",
                      disabled: true,
                      no: "16"
                    },
                    on: {
                      parentCallBack: function(item) {
                        return (_vm.form.projectOffice = item.value)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.ExpectTotalCost") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "17"
                    },
                    model: {
                      value: _vm.otherTotal.expectTotalCost,
                      callback: function($$v) {
                        _vm.$set(_vm.otherTotal, "expectTotalCost", $$v)
                      },
                      expression: "otherTotal.expectTotalCost"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.RealTotalCost") }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "18"
                    },
                    model: {
                      value: _vm.otherTotal.realTotalCost,
                      callback: function($$v) {
                        _vm.$set(_vm.otherTotal, "realTotalCost", $$v)
                      },
                      expression: "otherTotal.realTotalCost"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.ReceiveStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.isEdit, no: "19" },
                      model: {
                        value: _vm.form.receiveStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "receiveStatus", $$v)
                        },
                        expression: "form.receiveStatus"
                      }
                    },
                    _vm._l(_vm.receiveStatusList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: Number(item.code)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.ExpectProfitTate") } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "186px", border: "none" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "20"
                    },
                    model: {
                      value: _vm.form.expectProfitTate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "expectProfitTate", $$v)
                      },
                      expression: "form.expectProfitTate"
                    }
                  }),
                  _c("span", { staticStyle: { color: "#545557" } }, [
                    _vm._v("%")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.RealProfitTate") }
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "186px", border: "none" },
                    attrs: {
                      controls: false,
                      precision: 2,
                      disabled: true,
                      no: "21"
                    },
                    model: {
                      value: _vm.form.realProfitTate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realProfitTate", $$v)
                      },
                      expression: "form.realProfitTate"
                    }
                  }),
                  _c("span", { staticStyle: { color: "#545557" } }, [
                    _vm._v("%")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("Project.PayStatus") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.isEdit, no: "22" },
                      model: {
                        value: _vm.form.payStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "payStatus", $$v)
                        },
                        expression: "form.payStatus"
                      }
                    },
                    _vm._l(_vm.payStatusList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: Number(item.code)
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Project.Remarks") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { type: "textarea", disabled: _vm.isEdit, no: "23" },
                    model: {
                      value: _vm.form.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remarks", $$v)
                      },
                      expression: "form.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }